// extracted by mini-css-extract-plugin
module.exports = {"heading":"_1QxCnHFmDz9cjAoDz5wtep","headingText":"_30ovwSOa1c2R5U7WwPElYO","bookMarks":"ggIrwwL7NONSTxWGKGYz1"};